import { useState } from 'react';

import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { Modal } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import RepaymentScheduleModal from '../../../../../../../approvedView/repaymentScheduleModal/RepaymentScheduleModal';

export const ViewPaymentScheduleLink = ({
    selectedOffer,
    drawdownAmount
}: {
    selectedOffer: TFormalOffer | undefined;
    drawdownAmount: number;
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const offerId = selectedOffer?.offer_id;
    const canViewSchedule = Boolean(offerId && drawdownAmount);

    return (
        <>
            <button
                className="self-start text-s font-med text-structure-100 underline disabled:opacity-60"
                onClick={() => setIsOpen(true)}
                disabled={!canViewSchedule}
            >
                <FormattedMessage
                    id="_.loan_summary.view_payment_schedule"
                    defaultMessage="View payment schedule"
                />
            </button>

            {canViewSchedule && offerId && (
                <Modal
                    isOpen={isOpen}
                    onClose={() => setIsOpen(false)}
                    closeIcon
                >
                    <RepaymentScheduleModal
                        offerId={offerId}
                        drawdownAmount={drawdownAmount}
                    />
                </Modal>
            )}
        </>
    );
};
